

























import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
@Component
export default class SystemAppBar extends Vue
{
    @Action("SetIsDark") private _actionIsDark!: any;
    @Getter("IsItDark") private _getterIsDark!: boolean;
    /* istanbul ignore next */
    private get MDIIcon(): string
    {
        if (this._getterIsDark)
        {
            return "mdi-white-balance-sunny";
        }
        else
        {
            return "mdi-weather-night";
        }
    }
    /* istanbul ignore next */
    private ChangeIsDark(): void
    {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this._actionIsDark(!this._getterIsDark);
    }
}
